<template>
	<div class="latform-hypertalk-container">
		<div class="rankListBox">
			<div class="rankList" v-if="communitData.length">
				<div class="rankItem" v-for="(item,index) in communitData" :key="index">
					<div class="work">
						<img class="workImg" :src="item.img" />
						<div class="workInfo">
							<div class="workTitle ellipsis-1">
								{{item.title ? item.title : ''}}
							</div>
							<div class="workDesc ellipsis-2">
								{{item.content}}
							</div>
							<div class="peopleComment">
								<div class="people">
									<img class="peopleIcon" src="../assets/Home/people.png" />
									{{item.gz_num}}人
								</div>
								<div class="comment">
									<img class="commentIcon" src="../assets/Home/comment.png" />
									{{item.dt_num}}个
								</div>
							</div>
							<div class="tips">
								<div class="tip" v-for="(row,rowIndex) in item.label" :key="rowIndex">
									#{{row}}
								</div>
							</div>
						</div>
					</div>
					<div class="menu">
						<div class="menuItem goTo" @click="naviToSuperTalkDetails(item)">进入超话</div>
						<div class="menuItem follow" @click="communityDianzan(item)">
							{{item.gz_status == 0 ? '关注超话' : '取消关注'}}
						</div>
					</div>
				</div>
			</div>
			<el-empty description="暂无数据" v-else></el-empty>
		</div>
		<PagePagination v-if="communitData.length" style="padding: .32rem 0 .4rem;" :currentPage="currentPage"
			:total="total" @current-change="onPageChange" />
	</div>
</template>

<script>
	import PagePagination from '../components/PagePagination.vue'
	export default {
		name: 'MySuperTalk',
		components: {
			PagePagination,
		},
		data() {
			return {
				communitData: [],
				currentPage: 1, // 当前页码
				total: 1, // 总条数
			}
		},
		mounted() {
			this.myCommunityList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.myCommunityList()
			},
			myCommunityList() {
				this.$api.post('Release/my_community_list', {
					p: this.currentPage
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.communitData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//超话详情
			naviToSuperTalkDetails(item) {
				this.$router.push({
					path: '/super-talk-details',
					query: {
						id: item.sid,
						quId: item.fenqu && item.fenqu.length > 0 ? item.fenqu[0].id : ''
					}
				})
			},
			communityDianzan(item) {
				this.$api.post('/Release/follow', {
					id: item.sid,
				}).then(res => {
					if (res.code == 1) {
						this.$message.success(res.msg)
						this.myCommunityList()
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.latform-hypertalk-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
	}

	.rankListBox {
		width: 100%;
		margin-top: .16rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		overflow: hidden;

		.rankList {
			display: flex;
			flex-direction: column;
			padding: 0 .4rem 0 .4rem;

			.rankItem:last-child {
				border-bottom: none;
			}

			.rankItem {
				height: 2.24rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-bottom: .01rem solid #EAEAEA;

				.work {
					margin-left: .16rem;
					display: flex;

					.workImg {
						width: 1.6rem;
						height: 1.6rem;
						border-radius: .08rem;
						object-fit: cover;
					}

					.workInfo {
						width: 5.1rem;
						margin-left: .24rem;
						display: flex;
						flex-direction: column;

						.workTitle {
							font-weight: 600;
							font-size: .24rem;
							color: #000000;
						}

						.workDesc {
							margin-top: .1rem;
							font-weight: 400;
							font-size: .14rem;
							line-height: .2rem;
							color: #333333;
						}

						.peopleComment {
							margin-top: .16rem;
							display: flex;
							align-items: center;

							.people,
							.comment {
								margin-right: .2rem;
								display: flex;
								align-items: center;
								font-weight: 400;
								font-size: .14rem;
								color: #7C400E;
								line-height: .2rem;
							}

							.peopleIcon,
							.commentIcon {
								width: .14rem;
								height: .14rem;
								margin-right: .08rem;
							}
						}

						.tips {
							margin-top: .1rem;
							display: flex;
							align-items: center;

							.tip {
								font-size: .14rem;
								color: #786F22;
								line-height: .2rem;
								margin-right: .166rem;
							}
						}
					}
				}

				.menuItem {
					margin: .08rem 0;
					width: 1.2rem;
					height: .4rem;
					box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
					border-radius: .06rem;
					border: .01rem solid #E29358;
					font-weight: 400;
					font-size: .14rem;
					text-align: center;
					line-height: .4rem;
					cursor: pointer;
				}

				.goTo {
					border: .01rem solid #E29358;
					color: #E29358;
				}

				.follow {
					border: .01rem solid #706614;
					color: #706614;
				}
			}
		}
	}
</style>